module.exports = __webpack_public_path__ + "img/more-bg.3654a30f.png";